import { useIntl } from "react-intl";
import { ServiceIcon } from "../../../assets/SVGs/SVGs";
import SubInfo from "./SubInfo";

type Props = { data: any };

const SaleCardService = ({ data }: Props) => {
  const intl = useIntl();
  return (
    <div
      style={{ border: "1px solid #EEF0FF" }}
      className="flex items-center justify-between w-full px-3 py-2 rounded-lg"
    >
      <span className="flex items-center gap-2">
        <span>{ServiceIcon}</span> <span>{data?.itemable?.service?.name}</span>
      </span>
      <span>
        <SubInfo
          value={data?.itemable?.duration}
          label={intl.formatMessage({
            id: "minutes",
          })}
        />
      </span>
      <span>
        <SubInfo
          value={data?.itemable?.price}
          label={intl.formatMessage({
            id: "SARshort",
          })}
        />
      </span>
    </div>
  );
};

export default SaleCardService;
